<template>
    <!--<v-layout align-center justify-center fill-height class="pink page">-->
    <transition name="fitxar-animated" enter-active-class="animated slideInLeft" leave-active-class="animated slideOutRight" >
    <div class="page bgColor darken-2" v-bind:class="this.classBgColor">
        <v-layout align-center justify-center fill-height>
            <div class="text-xs-center">
                <div class="mb-4">
                    <h2 class="font-weight-light white--text">Hora actual:</h2>
                    <h1 class="font-weight-light white--text">{{ time }}</h1>
                </div>

                <div class="mb-4">
                    <h2 class="font-weight-light white--text">Última fitxada:</h2>
                    <h2 class="font-weight-light white--text">{{ this.textBotoUltimaFitxada }}: {{this.appObject.ultima_fitxada}}</h2>
                </div>

                <v-btn color="white" large outline light @click="fitxar">
                    <i class="material-icons mr-2" v-if="this.appObject.accio == 'S'">
                        check
                    </i>
                    <i class="material-icons mr-2" v-if="this.appObject.accio == 'E'">
                        check
                    </i>
                    {{textBoto}}
                </v-btn>

            </div>

        </v-layout>
    </div>
    </transition>
</template>

<script>
    import { mapState, mapActions } from "vuex"

    import axios from "axios"

    export default {
        data(){
            return{
                time: null
            }
        },
        computed: {
            ...mapState(['appObject', 'urlAPI']),

            classBgColor(){
                if(this.appObject.accio == 'E') return 'teal'
                else return 'error'
            },
            textBoto(){
                if(this.appObject.accio == 'E') return 'Fitxar Entrada'
                else return 'Fitxar sortida'
            },
            textBotoUltimaFitxada(){
                if(this.appObject.ultima_accio == "S") return "Sortida"
                else return "Entrada"
            }
        },
        methods: {
            ...mapActions(['setStorage', 'toggleTimer', 'startTimer', 'stopTimer']),

            async fitxar(){


                const params = new URLSearchParams(); //Per defecte "axios" serialitza l'objecte javascript a JSON, no tenim la API apunt per rebre json li hem d'enviar en "application/x-www-form-urlencoded"
                params.append('token', this.appObject.token);
                //Aquí hauríem de passar la latitiud i la longitud també!
                let dades = await axios.post(`${this.urlAPI}fitxar`, params)
                console.log('aqui van les dades rebudes de la fitxada!!!!', dades.data)

                //Inicialitzem el contador
                if(dades.data.ultima_accio == 'E') this.startTimer();
                else this.stopTimer();

                //Actualtizem les dades a la store i també al localStorage
                this.setStorage( dades.data )

                //Tornem a la home
                this.$router.push('/home')

            },

            checkTime(i) {
              if (i < 10) {
                i = "0" + i;
              }
              return i;
            },

            startTime() {
              var today = new Date();
              var h = today.getHours();
              var m = today.getMinutes();
              var s = today.getSeconds();
              // add a zero in front of numbers<10
              m = this.checkTime(m);
              s = this.checkTime(s);

              this.time = h + ":" + m + ":" + s
              
              let t = setTimeout(() => {
                this.startTime()
              }, 500);
            }

        },
        mounted(){
            this.startTime()
        }

    }
</script>
